export const FRIENDLY_NAMES_RECEIVED = 'FRIENDLY_NAMES_RECEIVED';
export const SET_FRIENDLY_NAMES = 'SET_FRIENDLY_NAMES';